// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"d2a04b15","513":"c4f92342","703":"40385cbb"}[chunkId] + ".chunk.js";
};